import { ArchivedDownloadBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/downloadBlock/archivedDownloadBlock.layout'
import { DownloadBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/downloadBlock/downloadBlock.layout'
import * as React from 'react'
import { IOWidget, Updater, fromJSX } from 'widgets-for-react'
import { PublicSiteState } from "../../../../../../../root/state"
import { CMSState } from '../../../../cms/blocks/types.gen'
import { DownloadBlockProps } from '../../../../cms/blocks/widgets/downloadBlock.gen'

export type archivedDownloadsBlockProps = {
  unarchivedBlock: DownloadBlockProps
  archivedBlock: DownloadBlockProps & {
    archived: 'archive_list_collapsed' | 'archive_list_open' | 'not_archived_list'
  }
}

export type archivedDownloadsPropsBlockStyle = Partial<{}>

const toggle_archive_collapsed = (newCollapsed: 'archive_list_collapsed' | 'archive_list_open') => (index: number) => (
  s0: CMSState
): CMSState => {
  let currentBlock = s0.blocks.get(index)
  if (currentBlock.kind != 'downloadsBlock') return s0
  let newBlock = {
    ...currentBlock,
    value: {
      ...currentBlock.value,
      archivedBlock: {
        ...currentBlock.value.archivedBlock,
        archived: newCollapsed
      }
    }
  }

  return { ...s0, blocks: s0.blocks.set(index, newBlock) }
}

export function archivedDownloadsBlock(
  props: archivedDownloadsBlockProps
): (
  s0: CMSState
) => IOWidget<PublicSiteState, Updater<CMSState>> {
  const { unarchivedBlock, archivedBlock } = props
  return (s1: CMSState) => (public_state: PublicSiteState) =>
    fromJSX((setState) => {
        return (
          <>
            {unarchivedBlock.items && unarchivedBlock.items.length > 0 && (
              <DownloadBlockLayout
                id={props.unarchivedBlock.index.toString()}
                title={props.unarchivedBlock.title}
                intro={props.unarchivedBlock.intro}
                items={props.unarchivedBlock.items.map((item) => ({
                  title: item.title,
                  text: item.text,
                  url: item.file_url
                }))}
              />
            )}
            {archivedBlock.items && archivedBlock.items.length > 0 && (
              <ArchivedDownloadBlockLayout
                id={`archive-download-block-${archivedBlock.index}`}
                items={archivedBlock.items.map((item) => ({
                  title: item.title,
                  text: item.text,
                  url: item.file_url
                }))}
                isOpen={archivedBlock.archived != 'archive_list_collapsed'}
                onOpen={() => setState((s) => toggle_archive_collapsed('archive_list_open')(archivedBlock.index)(s))}
                onClose={() =>
                  setState((s) => toggle_archive_collapsed('archive_list_collapsed')(archivedBlock.index)(s))
                }
              />
            )}
          </>
        )
      }
    )
}
